<template>
  <div>
    <MABanner
      v-for="(banner, idx) in last3Banners"
      :key="banner.id"
      :can-close="!!banner.dismissible"
      :title="banner.title"
      :message="banner.message"
      :type="banner.type"
      :link="banner.link"
      :link-text="banner.linkText"
      :class="idx === bannerStore.length - 1 ? 'mb-4' : 'mb-1'"
      @close="removeBanner(banner.id)"
    />

    <GenericModal
      v-if="onboardingRequired && !!user && !user?.website"
      :title="$t('setupRequired')"
      :message="$t('setupRequiredMessage')"
      :primary-button-text="$t('completeSetup')"
      :dismissible="false"
      @confirm="router.push({ name: RouteNames.ONBOARDING })"
    />
  </div>
</template>

<script setup lang="ts">
import MABanner from "../primevueComponents/MABanner.vue";
import GenericModal from "./GenericModal.vue";

const { bannerStore, removeBanner } = useAppBanner();
const { user } = useCurrentUser();
const router = useRouter();
const route = useRoute();

const onboardingRequired = computed(() => {
  if (isLocal || !route.name) return false;
  return (
    currentSessionInformation.onboardingRequired &&
    ![
      RouteNames.ONBOARDING,
      RouteNames.PLANS,
      RouteNames.PAYMENT_FAILED,
      RouteNames.INITIALIZE,
      RouteNames.WELCOME,
      RouteNames.TENANT_WELCOME,
    ].includes(route.name as symbol)
  );
});

const last3Banners = computed(() => {
  return bannerStore.slice(-3, bannerStore.length);
});
</script>
